import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['self']
  static classes = ['collapsed', 'collapsing', 'expanding']

  connect() {
    this.element[this.identifier] = this
  }

  expand() {
    this.selfTarget.classList.remove('collapsible-entity-chunk-collapsed')
    this.selfTarget.classList.add('collapsible-entity-chunk-expanding')
    this.selfTarget.addEventListener('animationend', () => {
      this.selfTarget.classList.remove('collapsible-entity-chunk-expanding')
    }, { once: true })
  }

  collapse() {
    this.selfTarget.classList.add('collapsible-entity-chunk-collapsing')
    this.selfTarget.addEventListener('animationend', () => {
      this.selfTarget.classList.remove('collapsible-entity-chunk-collapsing')
      this.selfTarget.classList.add('collapsible-entity-chunk-collapsed')
    }, { once: true })
  }

  isCollapsed() {
    return this.selfTarget.classList.contains('collapsible-entity-chunk-collapsed')
  }
}
